import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Gun Drilling Systems', path: '/gun-drilling-systems' },
    { name: 'About', path: '/about' },
    { name: 'News', path: '/news' },
  ];

  const navItems = [
    { label: 'Products & Services', href: '/#services' },
    { label: 'Industries', href: '/#applications' },
    { label: 'About', href: '/about' },
    { label: 'News', href: '/news' },
  ];

  const handleNavClick = (href: string) => {
    setIsMobileMenuOpen(false);
    
    if (href.startsWith('/#')) {
      const sectionId = href.substring(2);
      if (location.pathname !== '/') {
        window.location.href = href;
      } else {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#001E3C] shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1920px] mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="text-white text-2xl font-bold tracking-wider">
              HI-TAK
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              item.href.startsWith('/#') ? (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={(e) => {
                    if (location.pathname === '/') {
                      e.preventDefault();
                      handleNavClick(item.href);
                    }
                  }}
                  className="text-white/90 hover:text-[#00D9C9] text-sm font-medium transition-colors duration-200 whitespace-nowrap"
                >
                  {item.label}
                </a>
              ) : (
                <Link
                  key={item.label}
                  to={item.href}
                  className="text-white/90 hover:text-[#00D9C9] text-sm font-medium transition-colors duration-200 whitespace-nowrap"
                >
                  {item.label}
                </Link>
              )
            ))}
          </div>

          {/* Right Side Actions */}
          <div className="hidden lg:flex items-center space-x-4">
            <div className="relative">
              <input
                type="text"
                placeholder="Ask or search anything..."
                className="bg-white/10 text-white placeholder-white/60 px-4 py-2 pr-10 rounded text-sm focus:outline-none focus:ring-2 focus:ring-[#00D9C9] w-64"
              />
              <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-white/60 w-5 h-5 flex items-center justify-center"></i>
            </div>
            <a
              href="#contact"
              className="bg-[#00D9C9] text-[#001E3C] px-6 py-2 rounded font-semibold hover:bg-[#00F5E0] transition-all duration-200 text-sm whitespace-nowrap"
            >
              Contact Us
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-white w-10 h-10 flex items-center justify-center"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-[#001E3C] border-t border-white/10">
          <div className="px-6 py-4 space-y-4">
            {navItems.map((item) => (
              item.href.startsWith('/#') ? (
                <a
                  key={item.label}
                  href={item.href}
                  className="block text-white/90 hover:text-[#00D9C9] text-sm font-medium transition-colors duration-200"
                  onClick={(e) => {
                    if (location.pathname === '/') {
                      e.preventDefault();
                    }
                    handleNavClick(item.href);
                  }}
                >
                  {item.label}
                </a>
              ) : (
                <Link
                  key={item.label}
                  to={item.href}
                  className="block text-white/90 hover:text-[#00D9C9] text-sm font-medium transition-colors duration-200"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              )
            ))}
            <div className="pt-4 border-t border-white/10">
              <input
                type="text"
                placeholder="Search..."
                className="w-full bg-white/10 text-white placeholder-white/60 px-4 py-2 rounded text-sm focus:outline-none focus:ring-2 focus:ring-[#00D9C9] mb-3"
              />
              <a
                href="#contact"
                className="block text-center bg-[#00D9C9] text-[#001E3C] px-6 py-2 rounded font-semibold hover:bg-[#00F5E0] transition-all duration-200 text-sm"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
